
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}.main-wrapper{border-radius:var(--br-min);text-align:center}p{font-size:var(--fs-p-mini);margin:0;padding:2rem 1rem}.desktop p{padding:1.563rem 5.563rem}`;